<ng-container *transloco="let t">
<div class="p-1.5 pb-0">
  <div class="grid grid-cols-12">
    <div class="col-span-10">
      <mat-form-field appearance="outline" color="primary" class="hide-hint w-full">
        <input matInput [placeholder]="t('Search here')" [(ngModel)]="searchText"/>
      </mat-form-field>
    </div>
    <div class="col-span-2 flex justify-end">
      <button mat-icon-button mat-dialog-close class="flex! justify-center">
        <i-tabler name="x" class="size-4.5! flex!"></i-tabler>
      </button>
    </div>
  </div>
</div>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography search-dialog">
  <h4 class="text-lg font-medium m-0">{{ t('Quick Page Links') }}</h4>

  @for(item of navItemsData; track item.route) {
  <a [routerLink]="[item.route]" mat-dialog-close class="py-3 no-underline block">
    <h5 class="text-sm font-medium m-0">
      {{ item.displayName }}
    </h5>
    <span class="text-base">{{ item.route }}</span>
  </a>
  }
</mat-dialog-content>
</ng-container>
